import { useSiteConfig } from '../../lib/siteConfig';

export default function Marquee() {
  const cfg = useSiteConfig();
  const base = cfg.marquee || [];
  const items = [...base, ...base];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-cnib-navydeep py-5" data-testid="partners-marquee">
      <div className="flex w-max animate-marquee items-center gap-12 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-12 text-sm font-semibold uppercase tracking-[0.25em] text-slate-500">
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-orange-500" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-cnib-navydeep to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-cnib-navydeep to-transparent" />
    </div>
  );
}
